/**
 * Advertising utilities library.
 *
 * @file app/utils/advertising/library.js
 */

import PageActions from "../page/library";
import { APPCONTAINER_WP_WIDTH } from "./constants";
import { SECTIONS } from "../../constants/sections";

/**
 * Format ad exclusions as an array
 * @param {string} exclusions
 * @returns {string[]}
 */
export const getAdExclusions = (exclusions) => {
    if (exclusions === "") {
        return [];
    }
    return exclusions.split(",");
};

/**
 * @param {string} networkID
 * @param {string} section
 * @param {boolean} isOlympics
 * @param {string} adPageType
 * @param {string} adOrder
 * @returns {string} Ad Hierarchy
 */
export const constructAdHierarchy = (
    networkID,
    section,
    isOlympics,
    adPageType,
    adOrder
) => {
    let sec = section.replace(/-/g, "");
    if (section === "homepage") return `/${networkID}/home`;
    else if (section === "accessibility") return `/${networkID}/none`;
    else if (section.includes("/livestory")) {
        sec = sec.replace("/livestory", "");
        return `/${networkID}/${sec}/${adPageType}`;
    } else if (section.includes("player/play")) {
        if (typeof adOrder === "string" && adOrder !== "") {
            let newAdorder = adOrder;
            newAdorder = newAdorder
                .replace("sports/", "")
                .replace("/olympics", "olympics/video")
                .replace("/summer", "/sports")
                .replace("/winter", "/sports");
            return `/${networkID}/${newAdorder}`;
        } else if (isOlympics) return `/${networkID}/olympics/video`;
        else return `/${networkID}/${sec}/${adPageType}`;
    } else return `/${networkID}/${section}/${adPageType}`;
};

/**
 * Enable / disable wallpaper ad
 * @returns {void}
 */
export const wallpaperObserver = () => {
    let wallpaperEnabled = false;
    if (typeof MutationObserver === "undefined") {
        return null;
    }
    let observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === "class") {
                // if click-wp class exists we need to adjust the responsive navigation
                if (mutation.target.classList.contains("click-wp")) {
                    PageActions.enableWallpaper();
                    PageActions.viewportDimensionsHandler(
                        APPCONTAINER_WP_WIDTH
                    );
                    wallpaperEnabled = true;
                } else {
                    // when click-wp class is removed disableWallpaper
                    if (wallpaperEnabled === true) {
                        PageActions.disableWallpaper();
                        wallpaperEnabled = false;
                    }
                }
            }
        });
    });
    const config = { attributes: true };
    const target = document.querySelector(".appContainer");
    // pass in the target node, as well as the observer options
    // we will check if a class changes on the .appContainer
    if (target && observer) {
        observer.observe(target, config);
    }
};

/**
 * Check whether the Native Ads are enabled for the given section
 * @param {string} baseSection The section on which there might be a Native Ad
 * @returns {bool} A flag indicating whether the Native Ads are enabled for the given section
 */
export const nativeAdEnabled = (baseSection) => {
    const sectionConfig = SECTIONS[baseSection];
    const configNativeAd =
        sectionConfig &&
        sectionConfig.nativeAd !== undefined &&
        sectionConfig.nativeAd.enabled;
    const hasNativeAd = configNativeAd;
    return hasNativeAd;
};
